export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Brand.svg?7313d4f153eaebea18a53b2765b2199f";